export class SignataireEntity {
    id!: number;
    nom!: string;
    prenom!: string;
    nomEntreprise!: string;
    raisonSociale!: string;
    idEntreprise!: number;
    fonction!: string;
    hasSigned!: boolean;
	hasSignedEnvelope!: boolean;
    email!: string;
	sentToDocusign!: boolean;
	emailStyle: string = '';
    envelopeId!: string;
    envelopeIndex!: number;
    nature!: string;
	isIntervenant!: boolean;
	updatable: boolean = true;
	docusignRecipientId!: string;
}